// Plain words for the audit trail. Field keys are machinery, these are display.
import { addressOneLine } from "@/lib/shippingDestination";
import { toAddress } from "@/components/onboarding/AddressFields";

const FIELD_LABEL: Record<string, string> = {
  first_name: "First name",
  last_name: "Last name",
  legal_full_name: "Legal name",
  email: "Email",
  phone: "Phone",
  una_name: "Association name",
  una_name_status: "Association name status",
  una_name_confirmed_at: "Association name confirmed",
  mea_status: "MEA status",
  mea_signed_at: "MEA signed",
  mea_document_url: "MEA document",
  lease_status: "Lease status",
  lease_signed_at: "Lease signed",
  lease_document_url: "Lease document",
  nda_document_url: "NDA document",
  nda_signed_at: "NDA signed",
  legal_address: "Legal address",
  ca_address: "California address",
  ca_address_option: "California address choice",
  shipping_line1: "Shipping street",
  shipping_line2: "Shipping unit",
  shipping_city: "Shipping city",
  shipping_state: "Shipping state",
  shipping_zip: "Shipping ZIP",
  suite_number: "Suite number",
  suite_status: "Suite status",
  payment_status: "Payment status",
  fulfillment_stage: "Fulfillment stage",
  finance_segment: "Finance answers",
  chancery_interest: "Open to an administration conversation",
  chancery_interest_at: "Administration answer given",
  una_amount: "Association amount",
  monthly_amount: "Monthly amount",
  tracking_number: "Tracking number",
  home_situation: "Home situation",
  origin: "How they came in",
  user_id: "Account",
  qr_shortcode: "QR code",
};

const WORD_FIX: Record<string, string> = {
  una: "Association",
  mea: "MEA",
  nda: "NDA",
  ca: "California",
  zip: "ZIP",
  url: "link",
  id: "ID",
  qr: "QR",
  at: "date",
};

/** A plain label for any member record field key. */
export function fieldLabel(key: string): string {
  if (FIELD_LABEL[key]) return FIELD_LABEL[key];
  const words = key.split("_").map((w) => WORD_FIX[w] ?? w);
  const first = words[0] ?? key;
  return [first.charAt(0).toUpperCase() + first.slice(1), ...words.slice(1)].join(" ");
}

/** Addresses stored as JSON render as one compact line, never raw JSON. */
export function fieldValueText(value: unknown): string {
  if (value === null || value === undefined) return "";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  const raw = typeof value === "string" ? value : JSON.stringify(value);
  const trimmed = raw.trim();
  if (!trimmed) return "";
  if (trimmed.startsWith("{")) {
    try {
      const parsed = JSON.parse(trimmed) as Record<string, unknown>;
      if (parsed && ("line1" in parsed || "city" in parsed || "zip" in parsed)) {
        return addressOneLine(toAddress(parsed)) || "Empty";
      }
      const pairs = Object.entries(parsed)
        .filter(([, v]) => v !== null && v !== "" && v !== undefined)
        .map(([k, v]) => `${fieldLabel(k)}: ${String(v)}`);
      return pairs.join(", ") || "Empty";
    } catch {
      return trimmed;
    }
  }
  return trimmed;
}
